import { Link, useLocation } from 'react-router-dom';
import { Lock, LogOut } from 'lucide-react';
import { useAuth } from '@/auth';

// Page frame shared by every page (owner, 2026-10-11: as on the B-BBEE site): TCA logo + banner, the Xero
// title row with its orange line, account bar, content, account bar, letterhead footer.

// Shown twice (owner): at the top under the orange line and at the bottom, so the user can sign out
// or open Settings wherever they are on the page.
const AccountBar = ({ place }) => {
  const { user, signOut } = useAuth();
  const { pathname } = useLocation();
  if (!user) return null;
  return (
    <div className={`tca-account-bar tca-account-bar-${place}`} data-testid={`account-bar-${place}`}>
      <span className="tca-account-name">
        Signed in as <strong>{user.first_name} {user.last_name}</strong>
      </span>
      <div className="tca-account-actions">
        <button type="button" className="tca-signout" onClick={signOut} data-testid={`button-sign-out-${place}`}>
          <LogOut size={14} /> <span>Sign Out</span>
        </button>
        {/* The administrator (schalk@) only; charcoal, like the B-BBEE and Personal Tax sites' Settings button */}
        {user.role === 'admin' && pathname !== '/settings' && (
          <Link to="/settings" className="tca-settings-btn" data-testid={`settings-button-${place}`}>
            <Lock size={14} /> <span>Settings</span>
          </Link>
        )}
      </div>
    </div>
  );
};

const PageFrame = ({ subtitle, children }) => (
  <div className="app-container">
    <div className="form-wrapper">
      <header className="form-header">
        <img src="/images/TCA_Logo_Header.jpeg" alt="TC Auditors Logo" className="logo" />
        <img src="/images/TCA_Banner_Header.png" alt="Tax & Auditing Consultants" className="banner" />
        <div className="xs-title-row">
          <img src="/images/Xero_Logo.png" alt="Xero" className="xs-xero-logo" />
          <div>
            <h1 className="xs-title">Xero Setup Checklist</h1>
            <p className="xs-subtitle">{subtitle}</p>
          </div>
        </div>
      </header>
      <main className="xs-content">
        <AccountBar place="top" />
        {children}
        <AccountBar place="bottom" />
        <div className="letterhead-footer-container">
          <img src="/images/letterhead-footer.png" alt="TC Auditors Footer" className="letterhead-footer" />
        </div>
      </main>
    </div>
  </div>
);

export default PageFrame;
